export default "__VITE_ASSET__ffc64e33__"